

































































































































import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import { Site } from "@/shared/Site";

@Component
export default class ExpandableCriteres extends mixins(MyMixin) {
  @Prop() public filter!: any;
  @Prop() public selectedSite!: Site[];
  @Prop() public mesFiltres!: any;
  public filtresToShow: any = new Array();
  public documents = new Array();

  public mounted() {
    this.selectDocument("TICKET");
  }

  public updateParam() {
    this.$emit("updateParam", this.filter);
  }

  /**
   * mise a jour de la valeur d'un filtre
   */
  public updateData() {
    this.updateParam();
  }

  /**
   * methode permettant lors de l'activation d'un filtre de mettre à jour l'object à envoyer au serveur
   */
  public updateFiltres(filtre: any) {
    // console.log(filtre.format);
    // console.log(filtre.cle, filtre.$selected);
    if (filtre.$selected) {
      switch (filtre.format) {
        case "MONETAIRE":
        case "NUMBER":
          this.filter[filtre.cle] = 0;
          break;
        case "BOOLEAN":
          this.filter[filtre.cle] = true;
          break;
        case "TEXT":
          this.filter[filtre.cle] = "";
          break;
        case "CHOIX":
          this.filter[filtre.cle] = "";
          break;
        default:
          this.filter[filtre.cle] = "";
          break;
      }
    } else {
      delete this.filter[filtre.cle];
    }
    this.$forceUpdate();
    this.updateParam();
  }

  /**
   * méthode de comptage des filtres activés
   */
  public countActiveFilters() {
    const count = this.filtresToShow.filter((f: any) => f.$selected);
    return count.length;
  }

  @Watch("mesFiltres", { immediate: true })
  public onPropertyChangedBis(value: any, oldValue: any) {
    this.filtresToShow = this.mesFiltresToShow();
  }

  /**
   * méthode de filtrages des différents filtres existants
   * on supprime les filtres présentés ailleurs
   * (communs a tous les clients à savoir date, site, type document )
   */
  public mesFiltresToShow() {
    if (this.lesFiltres.length < 1) {
      return [];
    } else {
      const filtres = this.lesFiltres.filter((filtre: any) => {
        if (filtre.cle.includes("DOCUMENT")) {
          this.documents = filtre.choix;
        }
        if (
          filtre.cle.includes("LIB_SITE") ||
          filtre.cle.includes("RESTAURANT_ID") ||
          filtre.cle.includes("HORODATAGE") ||
          filtre.cle.includes("DATE") ||
          filtre.cle.includes("DOCUMENT") ||
          filtre.cle.includes("HEURE")
        ) {
          filtre.$display = false;
        } else {
          if (
            filtre.typeDocument !== "COMMUN" &&
            filtre.typeDocument !== this.filter.DOCUMENT
          ) {
            filtre.$display = false;
            if (Object.keys(this.filter).indexOf(filtre.cle) !== -1) {
              delete this.filter[filtre.cle];
            }
          } else {
            filtre.$display = true;
          }
          return this.makeMeAFilter(filtre);
        }
      });
      this.$forceUpdate();
      return filtres;
    }
  }

  /**
   * methode de selection du type de document que l'on veut chercher
   */
  public selectDocument(doc: string) {
    this.filter.DOCUMENT = doc;
    this.mesFiltresToShow();
    this.updateParam();
  }

  /**
   * ajout d'une propriété $selected au filtre pour la checkBox
   */
  private makeMeAFilter(filter: any) {
    filter.$selected = false;
    return filter;
  }

  /**
   * Fonction pour traduire les multiples choix des filtres
   * @param key
   * @private
   */
  private filterChoicesTranslator(key: unknown): string {
    if (typeof key !== "string") {
      return "";
    }

    const translated = this.$t(key);
    return typeof translated === "string" && translated !== key
      ? translated
      : key;
  }

  get global(): boolean {
    return this.$store.getters["getGlobal"];
  }

  get vendeurs() {
    this.selectedSite[0].vendeurs.sort();
    return this.selectedSite[0].vendeurs;
  }

  get lesFiltres(): any[] {
    const filtres = this.mesFiltres;
    filtres.sort((f1: any, f2: any) => {
      if (f1.order > f2.order) {
        return 1;
      }
      if (f1.order < f2.order) {
        return -1;
      }
      return 0;
    });
    return filtres;
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
